module.exports = __webpack_public_path__ + "img/green-1-oval-striped.9bc4b4a4.svg";